import {Base,Axios} from "@/api/Base"

export class EmployeeEntryRecordTermReport extends Base {
    path = "employeeEntryRecord/termReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}